/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// require("@rails/ujs").start()
require("turbolinks").start()
// require("channels")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)





// require("mmenu-js/dist/mmenu.css")

// import Mmenu     from "mmenu-js/dist/core/oncanvas/mmenu.oncanvas"

// import offCanvas from "mmenu-js/dist/core/offcanvas/mmenu.offcanvas"
// import screenReader from "mmenu-js/dist/core/screenreader/mmenu.screenreader"
// import scrollBugFix from "mmenu-js/dist/core/scrollbugfix/mmenu.scrollbugfix"

// import counters from "mmenu-js/dist/core/addons/counters/mmenu.counters"
// import navbars from "mmenu-js/dist/core/addons/navbars/mmenu.navbars"

// import bootstrap from "mmenu-js/dist/core/addons/bootstrap/mmenu.bootstrap"

import 'mmenu-js'
import './mmenuNav'
import Splide from '@splidejs/splide';

window.Splide = Splide;

import { Calendar } from '@fullcalendar/core';
import allLocales from '@fullcalendar/core/locales-all';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from "@fullcalendar/bootstrap"
import googlePlugin from "@fullcalendar/google-calendar"
import interactionPlugin from "@fullcalendar/interaction"
import multimonthPlugin from "@fullcalendar/multimonth"
import { dE } from '@fullcalendar/core/internal-common';

// App.cable.subscriptions.create({ channel: "CookieAuthChannel" }, {
//   connected() {
//     // Conexión exitosa.
//   },
//   disconnected() {
//     // Se desconectó.
//   },
//   received(data) {
//     // Maneja los datos recibidos del canal.
//   }
// });